import Svg from "../../../_assets/svg";

export const PersonalData = [
  {
    id: "/dashboard",
    title: "Overview",
    svg: Svg.overview_in.default,
    svg_active: Svg.overview_inactive.default
  }, 
  {
    id: "/my-application",
    title: "My Application",
    svg: Svg.app_inactive.default,
    svg_active: Svg.app_active.default
  }, 
  {
    id: "/generate-report",
    title: "Generate Report",
    svg: Svg.generate_inactive.default,
    svg_active: Svg.generate_active.default
  },
  // {
  //   id: "/whatsapp-template",
  //   title: "Whatsapp Template",
  //   svg: Svg.wa_nonactive.default,
  //   svg_active: Svg.wa_active.default
  // },
  {
    id: "/new-whatsapp-template",
    title: "Whatsapp Template",
    svg: Svg.wa_nonactive.default,
    svg_active: Svg.wa_active.default
  },
]

export const OrganizationData = [
  {
    id: "/profile/edit-organization",
    title: "API Documentation",
    svg: Svg.api_doc_inactive.default,
    svg_active: Svg.api_doc_active.default
  }
]

export default { PersonalData, OrganizationData };